import enhance from './GroupTrapMap.enhancer'
import GroupTrapMap from './GroupTrapMap'

export default enhance(GroupTrapMap)



// WEBPACK FOOTER //
// ./src/components/organisms/GroupTrapMap/index.js